import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 全局组件按照此法引入，非全局组件单独在页面引入
import component from './components/componentRegister'
import directives from './directives/index.js' // 全局指令封装
import filters from './filters/index.js' // 全局过滤器封装
import Tools from 'js-methods-library' // 工具函数引入
import axios from './http/index.js' // 数据接口
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 全局插件引入
// import './plugins/vconsole.js'

// 样式引入
import "./assets/css/tailwind.css"
import "./assets/css/sass/index.scss"
Vue.use(ElementUI);
// 全局指令
for (let key in directives) {
  Vue.directive(key, directives[key])
}

// 全局过滤器
for (let key in filters) {
  Vue.filter(key, filters[key])
}

Vue.config.productionTip = false

// 模块使用
Vue.use(component)
Vue.use(Tools)

// 原型挂载
Vue.prototype.$axios = axios

new Vue({
  beforeCreate() {
    // 设置事件总线，根据具体需求进行设置
    // Vue.prototype.$bus = this;
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app')
